import * as React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import "../MiniDrawer/MiniDrawer.css";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { IoMdLogOut } from "react-icons/io";

import SalesNewIcon from "../../../src/Icons/salesIcon.png";
import CarryMyPet from "../../../src/Icons/ERPSidebarimg.png";
import HRNewIcon from "../../../src/Icons/HrIcon.png";
import AccountsNewIcon from "../../../src/Icons/accountIcon.png";
import MastersNewIcon from "../../../src/Icons/MasterIcon.png";
import PricingNewIcon from "../../../src/Icons/PricingNewIcon.png";

// import PettyCashHistorylist from "../../pages/PettyCashHistorylist/PettyCashHistorylist";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer() {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [mastersOpen, setMastersOpen] = React.useState(false); // State for the "Masters" list
  const [salesOpen, setSalesOpen] = React.useState(false); // State for the "Sales" list
  const navigate = useNavigate(); // State for the Navigation list
  const [isInventoryOpen, setInventoryOpen] = useState(false);
  const [isChargesOpen, setChargesOpen] = useState(false);
  const [isRegionOpen, setRegionOpen] = useState(false);
  const [OperationsOpen, setOperationsOpen] = useState(false);
  const [AccountsOpen, setAccountsOpen] = React.useState(false);
  const [HROpen, setHROpen] = useState(false);

  const [isVendorFormOpen, setIsVendorFormOpen] = useState(false);
  const [isTDSFormatOpen, setIsTDSFormatOpen] = useState(false);
  const [isGSTFormatOpen, setIsGSTFormatOpen] = useState(false);
  const [isPettyCashOpen, setIsPettyCashOpen] = useState(false);
  const [isPettyCashOpenO, setIsPettyCashOpenO] = useState(false);
  const [isAccountMasterOpen, setIsAccountMasterOpen] = useState(false);


  const [isShipmentPanelOpen, setIsShipmentPanelOpen] = useState(false);
  const [isReportPanelOpen, setIsReportPanelOpen] = useState(false);
  const [isReconcillationPanelOpen, setIsReconcillationPanelOpen] = useState(false);
  const [isPurchasePanelOpen, setIsPurchasePanelOpen] = useState(false);


  const name = localStorage.getItem("name");
  const designation = localStorage.getItem("designation");

  const is_sales = localStorage.getItem("is_sales");
  const is_account = localStorage.getItem("is_account");
  const is_operation = localStorage.getItem("is_operation");
  const is_HR = localStorage.getItem("is_HR");
  const is_master = localStorage.getItem("is_master");
  const super_admin = localStorage.getItem("super_admin");

  const [isUserOpen, setUserOpen] = useState(false);
  const [isPricingOpen, setPricingOpen] = useState(false);



  const handleChargesClick = () => {
    setChargesOpen(!isChargesOpen);
  };

  const handleInventoryClick = () => {
    setInventoryOpen(!isInventoryOpen);
  };

  const handleRegionClick = () => {
    setRegionOpen(!isRegionOpen);
  };

  const handleAccountsOpen = () => {
    if (open === true) setAccountsOpen(!AccountsOpen);
  };


  const handleHROpen = () => {
    if (open === true) setHROpen(!HROpen);
  };

  const handleUserClick = () => {
    setUserOpen(!isUserOpen);
  };


  const handleDrawerOpen = () => {
    setOpen(true);
  };


  const handleVendorFormOpen = () => {

    setIsVendorFormOpen(!isVendorFormOpen)

  }
  const handleAccountMasterOpen = () => {
    setIsAccountMasterOpen(!isAccountMasterOpen)
  }


  const handleTDSFormatOpen = () => {
    setIsTDSFormatOpen(!isTDSFormatOpen);
  };

  const handleGSTFormatOpen = () => {
    setIsGSTFormatOpen(!isGSTFormatOpen);
  };

  const handleShipmentPanelOpen = () => {
    setIsShipmentPanelOpen(!isShipmentPanelOpen);
  };

  const handleReportPanelOpen = () => {
    setIsReportPanelOpen(!isReportPanelOpen);
  };

  const handleReconcillationPanelOpen = () => {
    setIsReconcillationPanelOpen(!isReconcillationPanelOpen);
  };

  const handlePurchasePanelOpen = () => {
    setIsPurchasePanelOpen(!isPurchasePanelOpen);
  };

  const handlePettyCashOpen = () => {
    setIsPettyCashOpen(!isPettyCashOpen);
  };
  const handlePettyCashOpenO = () => {
    setIsPettyCashOpenO(!isPettyCashOpenO);
  };

  const handlePricingOpen = () => {
    setPricingOpen(!isPricingOpen);
  };





  const handleDrawerClose = () => {
    setMastersOpen(false);
    setSalesOpen(false);
    setOperationsOpen(false);


    //setIsVendorFormOpen(false);
    setAccountsOpen(false);
    setHROpen(false);
    setPricingOpen(false);

    setOpen(false);
  };

  const handleMastersOpen = () => {
    if (open === true) setMastersOpen(!mastersOpen);
  };

  const handleSalesOpen = () => {
    if (open === true) setSalesOpen(!salesOpen);
  };

  const handleOperationsOpen = () => {
    if (open === true)
      setOperationsOpen(!OperationsOpen)
  };

  function SignOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("designation");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("Dept_ID");
    localStorage.removeItem("Desg_ID");

    localStorage.removeItem("is_sales");
    localStorage.removeItem("is_account");
    localStorage.removeItem("is_operation");
    localStorage.removeItem("is_HR");
    localStorage.removeItem("is_master");
    localStorage.removeItem("super_admin");
    window.location.reload();


  }

  function ChnagePassword() {
    navigate("/ChangePassword");
  }

  // ..........................................

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
          sx={{
            background: "linear-gradient(to right, #F15843, #A3519F, #5B489D)",
          }}
        >
          <FileDownloadOutlinedIcon
            className="rotate-icon"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: "none" }),
            }}
          >
            <MenuIcon />
          </FileDownloadOutlinedIcon>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography
              variant="h6"
              noWrap
              component="div"
              style={{ paddingTop: "17px", cursor: "pointer" }}

              onClick={() => navigate("/Dashboard")}
            >
              CarryMyPet ERP
            </Typography>

            {/* ..................................... */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginRight: "10px",
                }}
              >
                <NotificationsNoneIcon className="Notificationicon" />
              </div>
              <div
                style={{
                  borderRight: "1px solid #fff",
                  height: "73px",
                  marginRight: "10px",
                  color: "white",
                }}
              ></div>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginRight: "10px",
                }}
              >
                <PersonOutlineOutlinedIcon className="PersonOutlineOutlinedIcon" />
              </div>
              <div style={{ position: "relative" }}>
                <a
                  style={{ cursor: "pointer", marginLeft: "10px" }}
                  onClick={toggleDropdown}
                >
                  {/* <h4 style={{fontSize: '1rem'}}>Ankur Shing</h4> */}
                  <div style={{ paddingBottom: "1rem" }}>
                    <p style={{ fontSize: "14px", marginBottom: "-8px" }}>
                      Welcome {name}
                    </p>
                    <span style={{ fontSize: "9px" }}>{designation}</span>
                  </div>
                </a>
                {dropdownOpen && (
                  <ul
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      background: "#fff",
                      listStyle: "none",
                      margin: 0,
                      zIndex: 1,
                      width: "12rem",
                      padding: "19px",
                      borderRadius: "13px",
                      boxShadow: "0 1px 8px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <li
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        color: "black",
                      }}
                    >
                      <PersonOutlineOutlinedIcon className="PersonOutlineOutlinedIcon" />
                      Profile
                    </li>
                    <li
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        color: "black",
                      }}
                      onClick={() => ChnagePassword()}
                    >
                      Change Password
                    </li>

                    <div
                      style={{
                        border: "1px solid #000",
                        height: "2px",
                        width: "152px",
                        marginRight: "10px",
                        color: "balck",
                      }}
                    ></div>

                    <li
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        color: "black",
                      }}
                      onClick={() => SignOut()}
                    >
                      <IoMdLogOut />
                      Sign Out
                    </li>
                  </ul>
                )}
              </div>
            </div>

            {/* ....................... */}
          </div>
        </Toolbar>
      </AppBar>

      <Drawer variant="permanent" open={open} onMouseEnter={handleDrawerOpen} onMouseLeave={handleDrawerClose}
        style={{
          transitionDuration: '0.9s', // Adjust the duration as needed
          transitionTimingFunction: 'ease-in-out' // Add your desired timing function
        }}>
        {/*   */}
        <DrawerHeader className="DrawerHeaderht" style={{ background: "#F15843" }}  >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
            }}
          >
            {/* You can change this icon as needed */}
            <img
              alt="Loading..."
              className="form-image-MiniDrawer"
              src={CarryMyPet}
              onClick={() => navigate("/Dashboard")
              }

              style={{
                position: "relative", left: "-66px", cursor: "pointer", height: "35px",
                width: "85px"
              }}
            />
          </ListItemIcon>
          <FileDownloadOutlinedIcon
            onClick={handleDrawerClose}
            className="rotate-icon"
            style={{ color: "white" }}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </FileDownloadOutlinedIcon>
        </DrawerHeader>
        <Divider />

        {/* ------------------------------------Sales starts------------------------------------------------ */}
        {is_sales === "true" && (
          <List className="mainDeshboard">
            <ListItem key="Sales" disablePadding sx={{ display: "block" }} >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={handleSalesOpen} // Toggle the "Masters" list
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {/* You can change this icon as needed */}
                  <img
                    alt="Loading..."
                    className="form-image-MiniDrawer"
                    src={SalesNewIcon}
                    onClick={handleDrawerOpen}
                  />
                </ListItemIcon>
                <ListItemText primary="Sales" sx={{ opacity: open ? 1 : 0 }} />{" "}

              </ListItemButton>
            </ListItem>
            {salesOpen && (
              <List>
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/Dashboard")}
                    className="heading-2"

                  >
                    <ArrowRightAltIcon />
                    Dashboard
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/LeadList")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Lead List
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/AddLead")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Add Lead
                  </ListItemButton>
                </ListItem>
                <Divider />
                {/*  This is for opening new list on the click of region */}
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleRegionClick}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    User
                  </ListItemButton>
                </ListItem>
                {isRegionOpen && (
                  <List style={{ color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/StaffListMain")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Staff List
                      </ListItemButton>
                    </ListItem>
                    <ListItem>
                      <ListItemButton
                        onClick={() => navigate("/SalesTarget")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Sales Target
                      </ListItemButton>
                    </ListItem>

                    <ListItem
                      style={{ height: "3rem", margin: "2px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/UserAvailability")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        CheckAvailbility
                      </ListItemButton>
                    </ListItem>

                    {/* Add more sub-items as needed */}
                  </List>
                )}
                {/*  This is for opening new list on the click of region */}

                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/PriceCalculator")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Price Calculator
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/RateSheet")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Rate Sheet
                  </ListItemButton>
                </ListItem>
                <Divider />





                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/SalesOrder")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Orders
                  </ListItemButton>
                </ListItem>
                <Divider />

                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/LeadDataReportMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Lead Data Report
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => {
                      const ts = Math.floor(Date.now() / 1000); // Unix timestamp in milliseconds
                      window.open(
                        `http://chatbot.dbbworldwide.com/chat-mgt?ts=${ts}`,
                        "_blank"
                      );
                    }}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Chatbot
                  </ListItemButton>
                </ListItem>
                <Divider />

                {/* Add more nested items as needed */}
              </List>
            )}
          </List>
        )}

        {/* ------------------------------------Sales ends------------------------------------------------ */}



        {/* ------------------------------------Operations starts------------------------------------------------ */}

        {is_operation === "true" && (
          <List >
            <ListItem key="Operations" disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={handleOperationsOpen} // Toggle the "Masters" list
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img
                    alt="Loading..."
                    className="form-image-MiniDrawer"
                    src={MastersNewIcon}
                    onClick={handleDrawerOpen}
                  />{" "}
                  {/* You can change this icon as needed */}
                </ListItemIcon>
                <ListItemText primary="Operations" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
            {OperationsOpen &&
              (
                <List>
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={() => navigate("/DashboardOps")}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Dashboard
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={() => navigate("/orderlist")}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Order List
                    </ListItemButton>
                  </ListItem>

                  {/* <Divider />
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={() => navigate("/AddOrder")}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Add Order
                    </ListItemButton>
                  </ListItem> */}
                  <Divider />
                  {/*  This is for opening new list on the click of region */}

                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={handleRegionClick}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Inventory
                    </ListItemButton>
                  </ListItem>
                  {isRegionOpen && (
                    <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/PetCrateList")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Pet Crate List
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/PetCrateQuantityMaster")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Pet Crate Quantity
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/MicrochipListMain")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Microchip
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/MicrochipQuantityMain")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Microchip Quality
                        </ListItemButton>
                      </ListItem>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/PetTravelKit")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Pet Travel Kit
                        </ListItemButton>
                      </ListItem>

                      {/* Add more sub-items as needed */}
                    </List>
                  )}
                  {/*  This is for opening new list on the click of region */}

                  {/* <Divider />
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={() => navigate("/ExpenseList", { state: { expensetype: 'Other Expenses' } })}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Expense
                    </ListItemButton>
                  </ListItem> */}
                  <Divider />
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={handlePettyCashOpenO}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Petty Cash
                    </ListItemButton>
                  </ListItem>
                  {isPettyCashOpenO && (
                    <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/PettyCashList", { state: { role: "Operations" } })}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Request Cash
                        </ListItemButton>
                      </ListItem>

                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/PettyCashStatement")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Statement
                        </ListItemButton>
                      </ListItem>
                    </List>
                  )}
                  <Divider />
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={handleUserClick}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      User
                    </ListItemButton>
                  </ListItem>
                  {isUserOpen && (
                    <List style={{ color: "#5B489D" }}>
                      <ListItem
                        style={{ height: "3rem", margin: "-8px 1px 0px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/StaffListMainOperation")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          Staff List
                        </ListItemButton>
                      </ListItem>


                      <ListItem
                        style={{ height: "3rem", margin: "-6px 1px 0px 1px" }}
                      >
                        <ListItemButton
                          onClick={() => navigate("/UserAvailabilityOps")}
                          className="ListItemButton"
                        >
                          <ArrowRightAltIcon />
                          CheckAvailbility
                        </ListItemButton>
                      </ListItem>

                      {/* Add more sub-items as needed */}
                    </List>
                  )}

                  <Divider />
                  <ListItem className="ListItem">
                    <ListItemButton
                      onClick={() => navigate("/ConvertedLeadDataReport")}
                      className="heading-2"
                    >
                      <ArrowRightAltIcon />
                      Converted Lead report
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </List>
              )}
          </List>
        )}

        {/* ------------------------------------Operations ends------------------------------------------------ */}

        {/* ------------------------------------HR Start------------------------------------------------ */}
        {is_HR === "true" && (
          <List>
            <ListItem key="Human Resources" disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={handleHROpen}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img
                    alt="Loading..."
                    className="form-image-MiniDrawer"
                    src={HRNewIcon}
                    onClick={handleDrawerOpen}
                  />
                </ListItemIcon>
                <ListItemText primary="Human Resources" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
            {HROpen && (
              <List>
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/EmployeeMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Employee
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/TaskAssigned")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Task Assigned
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/dutyslip")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Duty Slip Book
                  </ListItemButton>
                </ListItem>
                <Divider />
              </List>
            )}
          </List>
        )}
        {/* ------------------------------------HR End------------------------------------------------ */}


        {/* ------------------------------------Account Start------------------------------------------------ */}
        {is_account === "true" && (
          <List >
            <ListItem key="Accounts And Finance" disablePadding sx={{ display: "block" }} >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={handleAccountsOpen} // Toggle the "Masters" list
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  {/* You can change this icon as needed */}
                  <img
                    alt="Loading..."
                    className="form-image-MiniDrawer"
                    src={AccountsNewIcon}
                    onClick={handleDrawerOpen}
                  />
                </ListItemIcon>
                <ListItemText primary="Accounts And Finance" sx={{ opacity: open ? 1 : 0 }} />{" "}
                {/*to change the name of text */}
              </ListItemButton>
            </ListItem>
            {AccountsOpen && (
              <List>
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/AccountsDashboard")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Dashboard
                  </ListItemButton>
                </ListItem>
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleShipmentPanelOpen}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Sales Register
                  </ListItemButton>
                </ListItem>
                {isShipmentPanelOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/ShipmentList")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Shipment List
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/EstimateList")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Estimate List
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/SalesSummary")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Sales Summary
                      </ListItemButton>
                    </ListItem>
                    <ListItem className="d-none"
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px", }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/Invoice")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Invoices
                      </ListItemButton>
                    </ListItem>
                    <ListItem className="d-none"
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/PaymentReceipt")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Payment Receipts
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/PaymentConfirmation")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Payment Confirmation
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/IndirectExpense")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Indirect Expense
                      </ListItemButton>
                    </ListItem>
                    <ListItem className="d-none"
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton d-none"
                      >
                        <ArrowRightAltIcon />
                        Refund & Cancellation
                      </ListItemButton>
                    </ListItem>
                  </List>
                )}
                <ListItem className="ListItem  d-none">
                  <ListItemButton
                    onClick={handlePurchasePanelOpen}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Purchase Register
                  </ListItemButton>
                </ListItem>
                {isPurchasePanelOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Vendors
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Bills
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Expense List
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Payment Mode
                      </ListItemButton>
                    </ListItem>
                  </List>
                )}
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleReconcillationPanelOpen}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Reconcillation
                  </ListItemButton>
                </ListItem>
                {isReconcillationPanelOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem className="d-none"
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Banking
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={handlePettyCashOpen}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Petty Cash
                      </ListItemButton>
                    </ListItem>
                    {isPettyCashOpen && (
                      <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/PettyCashList", { state: { role: "Accounts" } })}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            Request List
                          </ListItemButton>
                        </ListItem>

                        <ListItem className="d-none"
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            Balance History
                          </ListItemButton>
                        </ListItem>

                        <ListItem className="d-none"
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            Statement
                          </ListItemButton>
                        </ListItem>
                      </List>
                    )}
                  </List>
                )}
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleReportPanelOpen}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Reports
                  </ListItemButton>
                </ListItem>
                {isReportPanelOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/EmployeeExpenseDetail")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Employee Statement
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/ExpenseReport")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Expense Report
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/ProfitAndLoss")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Profit & Loss
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/BalanceSheet")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Balance Sheet
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/CustomerBalance")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Customer Balance
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Payable
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Vendor Balance
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Cash Flow Statement
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        TAX Summary
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={handleTDSFormatOpen}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        TDS Format
                      </ListItemButton>
                    </ListItem>
                    {isTDSFormatOpen && (
                      <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            TDS 194I
                          </ListItemButton>
                        </ListItem>

                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            TDS 194C
                          </ListItemButton>
                        </ListItem>
                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            TDS 194J
                          </ListItemButton>
                        </ListItem>
                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            TDS 192B
                          </ListItemButton>
                        </ListItem>
                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            TDS 192B-1
                          </ListItemButton>
                        </ListItem>
                      </List>
                    )}
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={handleGSTFormatOpen}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        GST Format
                      </ListItemButton>
                    </ListItem>
                    {isGSTFormatOpen && (
                      <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            GSTR-1
                          </ListItemButton>
                        </ListItem>

                        <ListItem
                          style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                        >
                          <ListItemButton
                            onClick={() => navigate("/")}
                            className="ListItemButton"
                          >
                            <ArrowRightAltIcon />
                            GSTR-3B
                          </ListItemButton>
                        </ListItem>
                      </List>
                    )}
                  </List>
                )}
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleVendorFormOpen}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Vendor Registration Form
                  </ListItemButton>
                </ListItem>
                {isVendorFormOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/SupplierMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Vendor List
                      </ListItemButton>
                    </ListItem>
                  </List>
                )}

                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/ShipmentExecutionSheet")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    ShipmentExecutionSheet
                  </ListItemButton>
                </ListItem>

                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleAccountMasterOpen}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Accounts Master
                  </ListItemButton>
                </ListItem>
                {isAccountMasterOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <Divider />
                    <ListItem className="ListItem mb-1">
                      <ListItemButton
                        onClick={() => navigate("/CostCenterMaster")}
                        className="heading-2"
                      >
                        <ArrowRightAltIcon />
                        CostCenterMaster
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem className="ListItem mb-1">
                      <ListItemButton
                        onClick={() => navigate("/SubCostCenterMaster")}
                        className="heading-2"
                      >
                        <ArrowRightAltIcon />
                        SubCostCenterMaster
                      </ListItemButton>
                    </ListItem>

                    <Divider />
                    <ListItem className="ListItem mb-1">
                      <ListItemButton
                        onClick={() => navigate("/ExpenseCategory")}
                        className="heading-2"
                      >
                        <ArrowRightAltIcon />
                        Expense Category
                      </ListItemButton>
                    </ListItem>
                    <Divider />
                    <ListItem className="ListItem mb-1">
                      <ListItemButton
                        onClick={() => navigate("/ExpenseDescription")}
                        className="heading-2"
                      >
                        <ArrowRightAltIcon />
                        Expense Description
                      </ListItemButton>
                    </ListItem>
                  </List>
                )}
              </List>
            )}
          </List>
        )}



        {/* ------------------------------------Master Start------------------------------------------------ */}
        {is_master === "true" && (
          <List>
            <ListItem key="Masters" disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
                onClick={handleMastersOpen} // Toggle the "Masters" list
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <img
                    alt="Loading..."
                    className="form-image-MiniDrawer"
                    src={MastersNewIcon}
                  />{" "}
                  {/* You can change this icon as needed */}
                </ListItemIcon>
                <ListItemText primary="Masters" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>
            </ListItem>
            {mastersOpen && ( // Render the nested list if mastersOpen is true
              <List>
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/AirFrieghtDomesticMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Add Frieght Charges
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/DepartmentMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Department
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/DesignationMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Designation
                  </ListItemButton>
                </ListItem>
                <Divider />
                {/*  This is for opening new list on the click of region */}

                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleRegionClick}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Region
                  </ListItemButton>
                </ListItem>
                {isRegionOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/RegionMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Region
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/CountryMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Country
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/StateMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        State
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/CityMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        City
                      </ListItemButton>
                    </ListItem>

                    {/* Add more sub-items as needed */}
                  </List>
                )}
                {/*  This is for opening new list on the click of region */}

                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/PetTypeMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Pet Type
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/PetBreedMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Pet Breed
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/StatusMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Status
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/StagesMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Stages
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/LeadSourceMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Lead Source
                  </ListItemButton>
                </ListItem>
                <Divider />

                {/*  This is for opening new list on the click of inventory */}
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleInventoryClick}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Inventory
                  </ListItemButton>
                </ListItem>
                {isInventoryOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/PetCrateMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        PetCrate
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/MicrochipMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Microchip
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/PetCrateQuantityMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Pet Crate Quantity
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/PetMicrochipQuantityMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Pet Microchip Quantity
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/assetsmaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Asset Master
                      </ListItemButton>
                    </ListItem>




                    {/* Add more sub-items as needed */}
                  </List>
                )}
                {/*  This is for opening new list on the click of inventory */}

                <Divider />

                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={handleChargesClick}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    Charges
                  </ListItemButton>
                </ListItem>

                {isChargesOpen && (
                  <List style={{ marginBottom: "-10px", color: "#5B489D" }}>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/ChargesMaster")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        Charges
                      </ListItemButton>
                    </ListItem>
                    <ListItem
                      style={{ height: "3rem", margin: "-8px 1px 1px 1px" }}
                    >
                      <ListItemButton
                        onClick={() => navigate("/MRPSheet")}
                        className="ListItemButton"
                      >
                        <ArrowRightAltIcon />
                        MRPSheet
                      </ListItemButton>
                    </ListItem>

                    {/* Add more sub-items as needed */}
                  </List>
                )}
                <Divider />
                <ListItem className="ListItem">
                  <ListItemButton
                    onClick={() => navigate("/SupplierMaster")}
                    className="heading-2"
                  >
                    <ArrowRightAltIcon />
                    {/* Add content for the nested list item */}
                    Supplier
                  </ListItemButton>
                </ListItem>
                <Divider />
                {/* Add more nested items as needed */}
              </List>
            )}
          </List>
        )}
        {/* ------------------------------------Master End------------------------------------------------ */}

        <Divider />
      </Drawer>
    </Box>
  );
}
